import { render, staticRenderFns } from "./level2List.vue?vue&type=template&id=5dcb96fe&scoped=true"
import script from "./level2List.vue?vue&type=script&lang=js"
export * from "./level2List.vue?vue&type=script&lang=js"
import style0 from "./level2List.vue?vue&type=style&index=0&id=5dcb96fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcb96fe",
  null
  
)

export default component.exports